module.exports = __webpack_public_path__ + "images/jobs/cardDevWeb.c3b0826b.svg";